<template>
    <div>
        <card-header icon="fa-dot-circle" />

        <card-body v-if="conference.id">
            <webix-scheduler :conf="conference" />

        </card-body>

        <card-footer>

        </card-footer>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import RenderComponent from "@/components/RenderComponent";

    import {client as http} from "@/http_client";
    import CardFooter from "../TIER/components/CardFooter";
    import WebixSlider from "../components/webix/WebixSlider";
    import WebixScheduler from "../components/webix/WebixScheduler";

    export default {
        components: {WebixScheduler, WebixSlider, CardFooter, RenderComponent, CardBody, CardHeader},
        props: ['card', 'props'],
        data: function () {
            return {
                conference: {}
            };
        },
        methods: {
            loadConference: function (force) {
                this.$emit('loading', true);
                http.get('conferences/2', {force}).then(response => {
                    this.conference = response.data;
                    this.$emit('loading', false);
                });
            }
        },
        watch: {},
        mounted: function () {
            this.loadConference();
        }
    };
</script>

<style lang="scss">
    .webix-test {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
    }
</style>
